import c from './index.module.scss';
import { useGTM } from '../../assets/hooks/useGTM';

const Button = ({ onClick, Icon, text, trackingName }) => {
  const { pushButtonClick } = useGTM();

  const handleClick = (e) => {
    if (trackingName) {
      pushButtonClick(trackingName, { button_text: text });
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button className={c.button} onClick={handleClick}>
      <Icon /> {text}
    </button>
  );
};

export default Button;
